import React, {useContext} from 'react';
import {TrackingContext} from '../TrackingContext.jsx';
import {CfEntry} from '../CfPreviewContext.jsx';
import {Link} from '@bonprix/design-system';
import {TrinityEvents} from '../../modules/teaser/trinity.js';
import {XRay} from '@teaser/scripts/components/XRay.jsx';

/**
 * @typedef {Object} LinkBarSingleLinkModel
 * @property {string} text
 * @property {string} entryId
 * @property {string} contentType
 */

/**
 * @typedef {TeaserLinkModel} LinkBar
 * @property {'LINK_BAR'} type
 * @property {string} entryId
 * @property {string} parentId
 * @property {string} contentType
 * @property {LinkBarSingleLinkModel[]} linkCollection
 */

/**
 * @param {LinkBarV2} model
 * @param {Device} device
 * @returns {JSX.Element}
 */
export function LinkBarV2({model}) {
    const parentContext = useContext(TrackingContext);
    return (
        <CfEntry entryId={model.entryId} contentType={model.contentType}>
            <article className={'content-platform__teaser content-platform__link-bar-v2'}>
                <XRay fieldId="internalName" />
                <ul className={'content-platform__link-bar__list'}>
                    {model.linkCollection.map((singleLink) => {
                        let landmarkConfig = {
                            id: singleLink.entryId,
                            cfEnvironment: parentContext.cfEnvironment,
                            teaserPageEntryId: parentContext.teaserPageEntryId,
                            page: parentContext.page,
                        };

                        return (
                            <CfEntry entryId={singleLink.entryId} contentType={singleLink.contentType}>
                                <li key={singleLink.entryId} className={'content-platform__link-bar__list-item'}>
                                    <div className={'content-platform__link-bar__list-item-link'}>
                                        <Link
                                            className={'content-platform__link-bar__list-item-link'}
                                            onClick={() => TrinityEvents.sendTeaserClick(landmarkConfig)}
                                            arrowPosition={'right'}
                                            href={singleLink.linkUrlBasePath}
                                            showArrow
                                        >
                                            {singleLink.text}
                                        </Link>
                                        <XRay fieldId="internalName" />
                                    </div>
                                </li>
                            </CfEntry>
                        );
                    })}
                </ul>
            </article>
        </CfEntry>
    );
}
